/*
  Scope & Field theme filters. Filters the collection grid in the browser from each card's
  data-sf-filter values (snippets/sf-filter-tokens.liquid), using the groups in the sidebar and the phone
  drawer (snippets/sf-filters.liquid). Values in one group widen the choice (Stereo or Compound); groups
  narrow it (Compound and Over 1000x). Counts show what each value would leave, and values that would
  leave nothing hide. The choice is kept in the address after #filter= so Back and shared links keep it,
  and it is applied again whenever Dawn's facets.js redraws the grid after a price, availability or sort
  change. The inputs have no name, and their input events stop here, so Dawn's filter forms never submit them.
*/
(function () {
  'use strict';

  if (window.SfFilters) return;

  var state = {};
  var gridRef = null;

  function config() {
    var el = document.querySelector('#ProductGridContainer [data-sf-filters-config]');
    if (!el) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return {};
    }
  }

  function inputs() {
    return Array.prototype.slice.call(document.querySelectorAll('[data-sf-filters] input[data-sf-key]'));
  }

  function items() {
    return Array.prototype.slice.call(document.querySelectorAll('#product-grid > li[data-sf-filter]'));
  }

  function tokensOf(li) {
    if (!li._sfTokens) {
      var map = {};
      li.getAttribute('data-sf-filter')
        .split('|')
        .forEach(function (t) {
          var i = t.indexOf(':');
          if (i < 1) return;
          var k = t.slice(0, i);
          (map[k] = map[k] || {})[t.slice(i + 1)] = true;
        });
      li._sfTokens = map;
    }
    return li._sfTokens;
  }

  function activeKeys() {
    return Object.keys(state).filter(function (k) {
      return state[k].length > 0;
    });
  }

  function matches(li, skipKey) {
    var tk = tokensOf(li);
    return activeKeys().every(function (k) {
      if (k === skipKey) return true;
      var have = tk[k];
      if (!have) return false;
      return state[k].some(function (v) {
        return have[v];
      });
    });
  }

  function setValue(key, value, on) {
    var list = state[key] || [];
    var i = list.indexOf(value);
    if (on && i === -1) list.push(value);
    if (!on && i !== -1) list.splice(i, 1);
    if (list.length) state[key] = list;
    else delete state[key];
  }

  function clearAll() {
    state = {};
    update();
  }

  function syncInputs() {
    inputs().forEach(function (input) {
      var list = state[input.getAttribute('data-sf-key')];
      input.checked = !!(list && list.indexOf(input.value) !== -1);
    });
  }

  function updateValues(list) {
    var cache = {};
    inputs().forEach(function (input) {
      var k = input.getAttribute('data-sf-key');
      var v = input.value;
      var id = k + ':' + v;
      if (!(id in cache)) {
        cache[id] = list.filter(function (li) {
          var t = tokensOf(li)[k];
          return t && t[v] && matches(li, k);
        }).length;
      }
      var label = input.closest('label');
      var off = cache[id] === 0 && !input.checked;
      input.disabled = off;
      if (label) {
        label.querySelectorAll('[data-sf-count]').forEach(function (c) {
          c.textContent = cache[id];
        });
        label.classList.toggle('disabled', off);
        label.classList.toggle('active', input.checked);
      }
    });

    document.querySelectorAll('[data-sf-filters] [data-sf-group]').forEach(function (group) {
      var key = group.getAttribute('data-sf-group');
      var groupInputs = group.querySelectorAll('input[data-sf-key]');
      var open = Array.prototype.some.call(groupInputs, function (i) {
        return !i.disabled;
      });
      group.hidden = !open;
      var n = (state[key] || []).length;
      group.querySelectorAll('[data-sf-selected]').forEach(function (el) {
        el.textContent = n ? '(' + n + ')' : '';
        el.hidden = n === 0;
      });
    });
  }

  function updateCount(shown) {
    var cfg = config();
    if (!cfg.countBase) return;
    var text = activeKeys().length ? cfg.countFiltered.replace('[shown]', shown) : cfg.countBase;
    ['ProductCount', 'ProductCountDesktop'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) el.textContent = text;
    });
    document.querySelectorAll('.mobile-facets__count').forEach(function (el) {
      el.textContent = text;
    });
  }

  function chipLabel(key, value) {
    var input = inputs().filter(function (i) {
      return i.getAttribute('data-sf-key') === key && i.value === value;
    })[0];
    if (!input) return value;
    var group = input.closest('[data-sf-group]');
    var groupLabel = group ? group.getAttribute('data-sf-group-label') : '';
    return (groupLabel ? groupLabel + ': ' : '') + input.getAttribute('data-sf-label');
  }

  function renderChips() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    grid.querySelectorAll('.sf-theme-chip, .sf-active-filters--own').forEach(function (el) {
      el.remove();
    });
    var dawnRow = grid.querySelector('.sf-active-filters');
    if (dawnRow) dawnRow.classList.remove('sf-active-filters--theme');

    var keys = activeKeys();
    if (!keys.length) return;
    var cfg = config();
    var list;
    var before = null;

    if (dawnRow) {
      dawnRow.classList.add('sf-active-filters--theme');
      list = dawnRow.querySelector('.sf-active-filters__list');
      var clear = list.querySelector('.sf-active-filters__clear');
      before = clear ? clear.closest('li') : null;
    } else {
      var row = document.createElement('div');
      row.className = 'sf-active-filters sf-active-filters--theme sf-active-filters--own';
      list = document.createElement('ul');
      list.className = 'sf-active-filters__list list-unstyled';
      list.setAttribute('role', 'list');
      before = document.createElement('li');
      var clearButton = document.createElement('button');
      clearButton.type = 'button';
      clearButton.className = 'sf-active-filters__clear link';
      clearButton.setAttribute('data-sf-clear-all', '');
      clearButton.textContent = cfg.clearAll || '';
      before.appendChild(clearButton);
      list.appendChild(before);
      row.appendChild(list);
      var collection = grid.querySelector('.collection');
      grid.insertBefore(row, collection || grid.firstChild);
    }

    /* chips follow the order of the groups and values in the sidebar */
    var seen = {};
    var chosen = [];
    inputs().forEach(function (input) {
      var k = input.getAttribute('data-sf-key');
      var id = k + ':' + input.value;
      if (seen[id] || !state[k] || state[k].indexOf(input.value) === -1) return;
      seen[id] = true;
      chosen.push([k, input.value]);
    });
    chosen.forEach(function (pair) {
      var k = pair[0];
      var v = pair[1];
      var li = document.createElement('li');
      li.className = 'sf-theme-chip';
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'sf-chip sf-chip--remove';
      button.setAttribute('data-sf-remove', k + ':' + v);
      button.appendChild(document.createTextNode(chipLabel(k, v)));
      if (cfg.closeIcon) button.insertAdjacentHTML('beforeend', cfg.closeIcon);
      var hidden = document.createElement('span');
      hidden.className = 'visually-hidden';
      hidden.textContent = cfg.removeOne || '';
      button.appendChild(hidden);
      li.appendChild(button);
      list.insertBefore(li, before);
    });
  }

  function renderEmpty(on) {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid) return;
    var box = grid.querySelector('.sf-filters-empty');
    if (!on) {
      if (box) box.remove();
      return;
    }
    if (box) return;
    var cfg = config();
    var ul = document.getElementById('product-grid');
    if (!ul) return;
    box = document.createElement('div');
    box.className = 'sf-filters-empty';
    box.setAttribute('role', 'status');
    var p = document.createElement('p');
    p.textContent = cfg.empty || '';
    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'button button--secondary';
    button.setAttribute('data-sf-clear-all', '');
    button.textContent = cfg.clearAll || '';
    box.appendChild(p);
    box.appendChild(button);
    ul.parentNode.insertBefore(box, ul.nextSibling);
  }

  function writeHash() {
    var parts = activeKeys().map(function (k) {
      return k + ':' + state[k].join(',');
    });
    var ours = location.hash.indexOf('#filter=') === 0;
    if (!parts.length && !ours) return;
    var hash = parts.length ? '#filter=' + parts.join(';') : '';
    if (hash === location.hash) return;
    history.replaceState(history.state, '', location.pathname + location.search + hash);
  }

  function readHash() {
    var h = '';
    try {
      h = decodeURIComponent(location.hash || '');
    } catch (e) {
      return;
    }
    if (h.indexOf('#filter=') !== 0) return;
    var known = {};
    inputs().forEach(function (i) {
      known[i.getAttribute('data-sf-key') + ':' + i.value] = true;
    });
    h.slice(8)
      .split(';')
      .forEach(function (part) {
        var i = part.indexOf(':');
        if (i < 1) return;
        var k = part.slice(0, i);
        part
          .slice(i + 1)
          .split(',')
          .forEach(function (v) {
            if (known[k + ':' + v]) setValue(k, v, true);
          });
      });
  }

  function update() {
    syncInputs();
    var list = items();
    var shown = 0;
    list.forEach(function (li) {
      var ok = matches(li);
      li.hidden = !ok;
      li.classList.toggle('sf-filtered-out', !ok);
      if (ok) shown += 1;
    });
    updateValues(list);
    updateCount(shown);
    renderChips();
    renderEmpty(list.length > 0 && shown === 0);
    writeHash();
  }

  function watch() {
    var grid = document.getElementById('ProductGridContainer');
    if (!grid || grid._sfWatched) return;
    grid._sfWatched = true;
    new MutationObserver(function () {
      var ul = document.getElementById('product-grid');
      if (ul !== gridRef) {
        gridRef = ul;
        update();
      }
    }).observe(grid, { childList: true });
  }

  function init() {
    if (!document.querySelector('[data-sf-filters]')) return;
    gridRef = document.getElementById('product-grid');
    watch();
    update();
  }

  document.addEventListener(
    'input',
    function (event) {
      if (event.target.closest && event.target.closest('[data-sf-filters]')) event.stopPropagation();
    },
    true
  );

  document.addEventListener('change', function (event) {
    var input = event.target.closest && event.target.closest('[data-sf-filters] input[data-sf-key]');
    if (!input) return;
    setValue(input.getAttribute('data-sf-key'), input.value, input.checked);
    update();
  });

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest) return;
    var remove = t.closest('[data-sf-remove]');
    if (remove) {
      var token = remove.getAttribute('data-sf-remove');
      var i = token.indexOf(':');
      setValue(token.slice(0, i), token.slice(i + 1), false);
      update();
      return;
    }
    var group = t.closest('[data-sf-clear-group]');
    if (group) {
      delete state[group.getAttribute('data-sf-clear-group')];
      update();
      return;
    }
    if (t.closest('[data-sf-clear-all]')) {
      clearAll();
      return;
    }
    /* Dawn's own Remove all links clear the theme filters as well */
    if (
      t.closest(
        '.active-facets__button-remove, a.sf-active-filters__clear, #FacetsWrapperMobile > .mobile-facets__footer .mobile-facets__clear'
      )
    ) {
      state = {};
      syncInputs();
    }
  });

  document.addEventListener('shopify:section:load', function () {
    init();
  });

  window.SfFilters = { update: update, clear: clearAll };

  readHash();
  init();
})();
